import { PrintSectionLayout } from "../../layout";

import type { QueryData } from "../../../model";

type Props = {
	// 追加料金
	additionalFees: QueryData["aliveItemsPerReservation"]["additionalFees"];
};

export const AdditionalFeesOfPrintComposition = ({ additionalFees }: Props) => {
	return (
		<PrintSectionLayout titleChildren={<p className="font-bold">追加料金</p>}>
			<div>
				{/*  */}
				<div className="grid w-full grid-cols-12">
					<div className="col-span-8 border border-zinc-200 p-1">
						<p className="font-semibold">名称</p>
					</div>
					<div className="col-span-2 border border-zinc-200 p-1">
						<p className="font-semibold">料金</p>
					</div>
					<div className="col-span-2 border border-zinc-200 p-1">
						<p className="font-semibold">お支払い金額</p>
					</div>
				</div>

				{/*  */}
				{additionalFees.map((additionalFee, index) => {
					const { name, totalPrice: _totalPrice, totalDiscountedPrice, hostInsertedPrice } = additionalFee;
					const priceText = `¥ ${_totalPrice.toLocaleString()}`;
					/**
					 * 順に優先度が高い
					 */
					const totalPrice = hostInsertedPrice ?? totalDiscountedPrice ?? _totalPrice;
					const totalPriceText = `¥ ${totalPrice.toLocaleString()}`;
					return (
						<div key={index} className="grid w-full grid-cols-12">
							{/* 名前 */}
							<div className="col-span-8 border border-zinc-200 p-1">
								<p>{name}</p>
							</div>

							{/* 料金 */}
							<div className="col-span-2 border border-zinc-200 p-1 text-right">
								<p>{priceText}</p>
							</div>

							{/* お支払い料金 */}
							<div className="col-span-2 border border-zinc-200 p-1 text-right">
								<p>{totalPriceText}</p>
							</div>
						</div>
					);
				})}
			</div>
		</PrintSectionLayout>
	);
};
